import { ClientContextPayload } from "src/utils/clientContext";

export const postClientContext = async (accessAuthToken: string, payload: ClientContextPayload): Promise<void> => {
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/users/client-context`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${accessAuthToken}`,
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`Failed to save client context: ${response.status}`);
  }
};
